import { render, staticRenderFns } from "./WebUserEmail.vue?vue&type=template&id=02ca4afe&lang=pug&"
import script from "./WebUserEmail.vue?vue&type=script&lang=ts&"
export * from "./WebUserEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports